/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageClientSummary,
  ToolUsageClientSummary$inboundSchema,
} from "./toolusageclientsummary.js";

/**
 * Top MCP clients for the selected filters and time range
 */
export type GetToolUsageClientsResult = {
  /**
   * Top MCP clients for the selected filters and time range
   */
  clients: Array<ToolUsageClientSummary>;
};

/** @internal */
export const GetToolUsageClientsResult$inboundSchema: z.ZodMiniType<
  GetToolUsageClientsResult,
  unknown
> = z.object({
  clients: z.array(ToolUsageClientSummary$inboundSchema),
});

export function getToolUsageClientsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageClientsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetToolUsageClientsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageClientsResult' from JSON`,
  );
}
